export default __webpack_public_path__ + "static/media/product-image-18.c7286c45.jpg";